module.exports = __webpack_public_path__ + "img/banner10-2@2x.a09a884c.jpg";